import {
  Box,
  TextField,
  Button,
  Slider,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import PopupForm from "../../Components/PopupForm";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CustomeSelectField from "../../Components/CustomeSelectField";
import CustomTextField from "../../Components/CustomTextField";
import Cookies from "universal-cookie";
import axios from "../../assets/js/AxiosInterceptors";
import { useTranslation } from "react-i18next";
import host from "../../assets/js/Host";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ContainerOfInputFields } from "../../Components/ThemDesign";
import SyncIcon from "@mui/icons-material/Sync";
import { setGlobalLoading } from "../../reduxStore/SettingsReducer";

const cookies = new Cookies();
const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  console.log('dasdasdasdasdasdasjlaksdalksd=>',props?.type)
  return (
    <Box className="Container-fluid">
      <Box className="row pt-4">
        <Box className="col-12 col-sm-12 col-md-12 m-auto d-flex flex-column justify-content-center align-items-center">
          <CustomTextField
            label={"Title"}
            haswidth={true}
            value={props?.taskTitle}
            error={false}
            customWidth="100%"
            hasMultipleLine={true}
            // paddingHorizontal="2px 10px 2px 5px !important"
            message={""}
            readOnly={false}
            onChange={(e) => {
              props?.setTaskTitle(e.target.value);
            }}
            onClearClick={() => {
              props?.setTaskTitle("");
            }}
          />
          {props?.taskType == "واجبات التركيب والصيانة" ||
          props?.taskType == "واجبات تركيب وصيانة - محافظات" ? (
            <>
              <Box sx={{ marginTop: "10px" }}></Box>
              <CustomTextField
                label={"Number Of Unit"}
                haswidth={true}
                customWidth="100%"
                value={props?.numOfUnits ? props?.numOfUnits : 0}
                error={false}
                hasMultipleLine={true}
                message={""}
                readOnly={false}
                onChange={(e) => {
                  if (!isNaN(e?.target?.value))
                    props?.setNumOfUnits(e.target.value);
                }}
                onClearClick={() => {
                  props?.setNumOfUnits("");
                }}
              />
              <Box sx={{ marginTop: "10px" }}></Box>

              <CustomTextField
                label={"Contact Number"}
                haswidth={true}
                customWidth="100%"
                value={props?.contactedNum}
                error={false}
                hasMultipleLine={true}
                message={""}
                readOnly={false}
                onChange={(e) => {
                  if (!isNaN(e?.target?.value))
                    props?.setContactedNum(e.target.value);
                }}
                onClearClick={() => {
                  props?.setContactedNum("");
                }}
              />
              <Box sx={{ marginTop: "10px" }}></Box>

              <CustomTextField
                label={"Contacted Person"}
                haswidth={true}
                customWidth="100%"
                value={props?.contactedPerson}
                error={false}
                hasMultipleLine={true}
                message={""}
                readOnly={false}
                onChange={(e) => {
                  props?.setContactedPerson(e.target.value);
                }}
                onClearClick={() => {
                  props?.setContactedPerson("");
                }}
              />
            </>
          ) : null}

          <Box sx={{ marginTop: "10px" }}></Box>
          <CustomTextField
            label={"Description"}
            haswidth={true}
            customWidth="100%"
            value={props?.description}
            error={false}
            hasMultipleLine={true}
            message={""}
            readOnly={false}
            onChange={(e) => {
              props?.setDescription(e.target.value);
            }}
            onClearClick={() => {
              props?.setDescription("");
            }}
          />
          <Box sx={{ marginTop: "10px" }}></Box>
          <CustomeSelectField
            label={"Task Type"}
            customWidth="100%"
            haswidth={true}
            value={props?.taskType1}
            list={props?.type ? props?.type : []}
            customGetOptionLabel={(option) => option?.label}
            error={false}
            message={[]}
            multiple={false}
            readOnly={false}
            focused={true}
            onChange={(e, newValue) => {
              props?.setTaskType1(newValue);
              props?.setTypeId(newValue?.value);
            }}
            onClearClick={() => {
              props?.setTaskType1(null);
              props?.setTypeId(null);
            }}
          />
          {props?.taskType == "واجبات التركيب والصيانة" ||
          props?.taskType == "واجبات تركيب وصيانة - محافظات" ? (
            <>
              <Box
                sx={{
                  marginTop: "10px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <CustomeSelectField
                  label={"Add Geofence"}
                  haswidth={true}
                  customWidth="100%"
                  value={
                    props?.selectedGeofence && props?.selectedGeofence?.label
                      ? props?.selectedGeofence
                      : null
                  }
                  list={props?.geofences ? props?.geofences : []}
                  customGetOptionLabel={(option) => option?.label}
                  error={false}
                  message={[]}
                  multiple={false}
                  readOnly={false}
                  focused={true}
                  onChange={(e, newValue) => {
                    props?.setSelectedGeofence(newValue);
                    props?.handleGeo(newValue?.label);
                  }}
                  onClearClick={() => {
                    props?.setSelectedGeofence(null);
                  }}
                />

                <IconButton
                  sx={{
                    backgroundColor: "#fff",
                    boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                  }}
                  onClick={() => {
                    const { onRefreshGeo } = props?.onRefreshGeo;
                    onRefreshGeo();
                  }}
                >
                  <SyncIcon sx={{ color: "#1e6a99" }} />
                </IconButton>
              </Box>
            </>
          ) : null}
          {props?.createMode ? (
            <>
              <Box sx={{ marginTop: "10px" }}></Box>

              <CustomeSelectField
                label={"Task Assign To"}
                haswidth={true}
                customWidth="100%"
                value={props?.selectedAssigners ? props?.selectedAssigners : []}
                list={props?.users ? props?.users : []}
                customGetOptionLabel={(option) => option?.name}
                error={false}
                message={[]}
                multiple={true}
                readOnly={false}
                focused={true}
                onChange={(e, newValue) => {
                  props?.setSelectedAssigners(newValue);
                }}
                onClearClick={() => {
                  props?.setSelectedAssigners(null);
                }}
              />
            </>
          ) : null}
          <Box sx={{ marginTop: "10px" }}></Box>

          <CustomeSelectField
            label={"Task Monitor"}
            haswidth={true}
            customWidth="100%"
            value={props?.selectedUser}
            list={props?.users ? props?.users : []}
            customGetOptionLabel={(option) => option?.name}
            error={false}
            message={[]}
            multiple={false}
            readOnly={false}
            focused={true}
            onChange={(e, newValue) => {
              props?.setSelectedUser(newValue);
            }}
            onClearClick={() => {
              props?.setSelectedUser(null);
            }}
          />
          <Box sx={{ marginTop: "10px" }}></Box>
          <Box
            sx={{
              backgroundColor: "#fff",
              boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
              borderRadius: "2px",
              width: "97%",
              padding: "5px 12px",
              borderLeft: "5px solid #1e6a99",
            }}
          >
            <span style={{ fontWeight: "Bold" }}>Task Weight</span>
            <Slider
              style={{ width: "100%" }}
              defaultValue={props.weight}
              value={props?.weight}
              onChange={props?.handleChangeweight}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={10}
            />
          </Box>
          {props?.createMode ? (
            <Box
              sx={{
                margin: "10px 0 0px 0",
                width: "97%",
                height: "55px",
                backgroundColor: "#fff",
                boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                paddingLeft: "10px",
                display: "flex",
                alignItems: "center",
                borderLeft: "5px solid #1e6a99",
                cursor: "pointer",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props?.isDeadLine}
                    onChange={(e) => {
                      props?.setIsDeadLine(e?.target?.checked);
                    }}
                  />
                }
                sx={{
                  width: "100%",
                }}
                label="Set DeadLine"
              />
            </Box>
          ) : null}

          {props?.createMode ? (
            !props?.isDeadLine ? null : (
              <ContainerOfInputFields
                mainTheme={maintheme}
                customeWidth={"100%"}
                hasError={false}
                haswidth={true}
              >
                <Box
                  sx={{
                    position: "relative",
                    // margin: "5px 0",
                    width: "100%",
                    backgroundColor: "#fff",
                  }}
                  className="mt-3 orderdata"
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label={"Deadline Date"}
                      inputFormat="MM/DD/YYYY HH:mm:ss"
                      value={props?.startDate}
                      minDate={new Date()}
                      inputProps={{
                        placeholder: "لم يتم التحديد",
                      }}
                      // maxDate={new Date()}
                      onChange={(date) => props?.handleChange(date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="filled"
                          focused={true}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "لم يتم التحديد",
                          }}
                        />
                      )}
                    />
                    {props?.startDate ? (
                      <CloseIcon
                        className="closeIcon"
                        onClick={() => props?.handleChange(null)}
                        sx={{
                          right: "37px !important",
                          top: "14px !important",
                        }}
                      />
                    ) : null}
                  </LocalizationProvider>
                </Box>
              </ContainerOfInputFields>
            )
          ) : (
            <ContainerOfInputFields
              mainTheme={maintheme}
              customeWidth={"100%"}
              hasError={false}
              haswidth={true}
            >
              <Box
                sx={{
                  position: "relative",
                  // margin: "5px 0",
                  width: "100%",
                  backgroundColor: "#fff",
                }}
                className="mt-3 orderdata"
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    label={"Deadline Date"}
                    inputFormat="MM/DD/YYYY HH:mm:ss"
                    value={props?.startDate}
                    minDate={new Date()}
                    inputProps={{
                      placeholder: "لم يتم التحديد",
                    }}
                    // maxDate={new Date()};
                    onChange={(date) => props?.handleChange(date)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="filled"
                        focused={true}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: "لم يتم التحديد",
                        }}
                      />
                    )}
                  />
                  {props?.startDate ? (
                    <CloseIcon
                      className="closeIcon"
                      onClick={() => props?.handleChange(null)}
                      sx={{
                        right: "37px !important",
                        top: "14px !important",
                      }}
                    />
                  ) : null}
                </LocalizationProvider>
              </Box>
            </ContainerOfInputFields>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function EditTask(props) {
  const [data, setData] = useState([]);
  const [taskTitle, setTaskTitle] = useState(props?.title);
  const [user, setUser] = useState("");
  const [description, setDescription] = useState(props?.desc);
  const [deadTime, setDeadTime] = useState("");
  const [statusId, setStatusId] = useState("");
  const [startDate, setStartDate] = useState(
    props.time === "1970-01-01T00:00:00.000Z" ? "" : new Date(props?.time)
  );
  const [typeId, setTypeId] = useState("");
  const [type, setType] = useState(props?.type);
  const [numOfUnits, setNumOfUnits] = useState(props?.num_of_units);
  const [contactedPerson, setContactedPerson] = useState(
    props?.contacted_person
  );
  const [selectedGeofence, setSelectedGeofence] = useState(null);
  const [geofences, setGeofences] = useState([]);
  const [contactedNum, setContactedNum] = useState(props?.contacted_num);
  const [moniter, setMoniter] = useState([]);
  const [weight, setWeight] = useState("");
  const [loading, setLoading] = useState([]);
  const [customer, setCustomer] = useState("");
  const [users, setUsers] = useState([]);
  const [spin, setSpin] = useState(false);
  const [taskType1, setTaskType1] = useState("");
  const [selected, setSelected] = useState([props?.customer?.id]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedAssigners, setSelectedAssigners] = useState([]);
  const [isDeadLine, setIsDeadLine] = useState(false);
  const dispatch = useDispatch();
  const handleChange = (date) => {
    setStartDate(date);
  };
  const handleChangeweight = (event, newValue) => {
    setWeight(newValue);
  };

  const handleGeo = (value) => {
    if (value != "الموقع غير حقيقي") {
      setDescription(
        description?.replace(
          "الموقع غير حقيقي، يرجى الاتصال على الدعم لمعرفة الموقع الحقيقي\n",
          " "
        )
      );
    } else if (value == "الموقع غير حقيقي") {
      if (description?.includes(value)) {
        return;
      } else {
        setDescription(
          "الموقع غير حقيقي، يرجى الاتصال على الدعم لمعرفة الموقع الحقيقي\n"
        );
      }
    }
  };

  useEffect(() => {
    console.log("customers data", props?.Allcustomer);
    if (props?.Allcustomer?.length > 0) {
      let arr = [];
      props?.Allcustomer?.length > 0 &&
        props?.Allcustomer?.map((itm) => {
          arr.push({
            ...itm,
            id: itm?.value,
          });
        });
      setCustomers(arr);
    }
  }, [props?.Allcustomer]);

  useEffect(() => {
    console.log("sdasdasdsadCustomer=>", props.customer);
    setSelectedCustomer(props.customer);
  }, [props.customer]);

  useEffect(() => {
    console.log("users data", props?.users);
    if (props?.users?.length > 0) {
      let arr = [];
      props?.users?.length > 0 &&
        props?.users?.map((itm) => {
          arr.push({
            name: itm?.label,
            id: itm?.value,
          });
        });
      setUsers(arr);
    }
  }, [props?.users]);

  useEffect(() => {
    console.log("sdasdasdsadMonitor=>", props?.monitor);
    setSelectedUser(props?.monitor);
  }, [props.monitor]);
  const assign_user = (id) => {
    var headers = {
      jwt: cookies.get("token"),
    };
    axios({
      url: host + `tasks/assign/${id}`,
      method: "POST",
      headers: headers,
      data: {
        users_id: selectedAssigners?.map((itm) => itm?.id),
      },
    })
      .then((res) => {
        // console.log(response.data);
        if (res.data.status === true) {
          // toast.success('task created successfully')
          if (moniter !== null) {
            axios({
              url: host + `tasks/assign/monitor/${id}`,
              method: "PUT",
              headers: headers,
              data: {
                monitor_user_id: selectedUser?.id || 9,
              },
            }).then((res) => {
              toast.success("task created successfully");
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
              if(props?.onRefTask) {
                const { onRefTask } = props;
                onRefTask();
              }
            });
          } else {
            toast.success("task created successfully");
            props?.setAddForm(false);
            dispatch(setGlobalLoading(false));
            if(props?.onRefTask) {
              const { onRefTask } = props;
              onRefTask();
            }
          }
        } else if (res.data.status === false) {
          toast.error(res.data.data.message.text);
          dispatch(setGlobalLoading(false));
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        dispatch(setGlobalLoading(false));
      });
  };
  useEffect(()=>{
    setType(props?.type)
    if(props?.isGeneralTask){
      setTaskType1(props?.type&&props?.type?.length?props?.type[0]:null);
      setTypeId(props?.type&&props?.type?.length?props?.type[0]?.value:null);
    }
  },[props?.type])

  const submit = async () => {
    console.log("typeId", taskType1);
    var headers = {
      jwt: cookies.get("token"),
    };

    console.log("asdasdaDate", 0);

    if (props?.createMode) {
      console.log("asdasdaDate", 1);
      if (isDeadLine === true && startDate != null) {
        console.log("asdasdaDate", 2);

        var milliseconds = new Date(startDate)?.getTime() + 3 * 60 * 60 * 1000; //add three hours
        var correctedDeadTime = new Date(milliseconds);
        console.log("asdasdaDate", 3);
      } else if (isDeadLine) {
        toast.warn("you must enter DeadLine");
        return;
      }
      // adding conditions to prevent site from crushing.
      if (taskTitle?.length < 5) {
        return toast.error("Title must be more than 5 char");
      }
      if (taskType1 === "") {
        return toast.error("Select task type first");
      }
      if (selectedAssigners?.length < 1) {
        return toast.error("Select at least one user to assign");
      }
      if (selectedUser === null) {
        return toast.error("Select Task monitor first");
      }
      dispatch(setGlobalLoading(true));
      let create_path=`Back-${(host + `tasks/task`)} , Front:${window.location.origin+window.location.pathname}`
      let res = await axios({
        url: host + `tasks/task`,
        method: "POST",
        headers: headers,
        data: {
          task_name: taskTitle ? taskTitle?.replace(/'/g, "") : "",
          description: description ? description.replace(/['"]/g, "") : "",
          dead_time: correctedDeadTime,
          main_task_id: "0",
          task_type_id: taskType1?.value,
          contacted_num: contactedNum,
          num_of_units: numOfUnits,
          // priority_id:this.state.priority_id,
          geo_name: selectedGeofence?.label,
          geo_x: selectedGeofence?.dimen[0],
          geo_y: selectedGeofence?.dimen[1],
          weight: weight,
          create_path:create_path
        },
      });
      if (res.data.status === true) {
        if (selectedAssigners?.length > 0) {
          assign_user(res.data.data.data.task_id);
        } else {
          if (selectedUser !== null) {
            axios({
              url: host + `tasks/assign/monitor/${res.data.data.data.task_id}`,
              method: "PUT",
              headers: headers,
              data: {
                monitor_user_id: selectedUser?.id || 9,
              },
            }).then((res) => {
              toast.success("task created successfully");
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
              if(props?.onRefTask) {
                const { onRefTask } = props;
                onRefTask();
              }
            });
          } else {
            toast.success("task created successfully");
            props?.setAddForm(false);
            dispatch(setGlobalLoading(false));
            if(props?.onRefTask) {
              const { onRefTask } = props;
              onRefTask();
            }
          }
        }
      } else if (res.data.status === false) {
        toast.error(res.data.data.message.text);
        dispatch(setGlobalLoading(false));
      }
    } else {
      if (startDate !== "") {
        var milliseconds = new Date(startDate)?.getTime() + 3 * 60 * 60 * 1000; //add three hours
        var correctedDeadTime = new Date(milliseconds);
      }
      dispatch(setGlobalLoading(true));
      axios({
        url: host + `tasks/task/${props.id}`,
        method: "PUT",
        headers: headers,
        data: {
          task_title: taskTitle ? taskTitle?.replace(/'/g, "") : "",
          description: description ? description.replace(/['"]/g, "") : "",
          num_of_units: numOfUnits,
          contacted_num: contactedNum,
          contacted_person: contactedPerson,
          dead_time: correctedDeadTime,
          task_type_id: taskType1?.value,
          geo_name: selectedGeofence?.label,
          geo_x: selectedGeofence?.dimen[0],
          geo_y: selectedGeofence?.dimen[1],
          weight: weight,
        },
      })
        .then((res) => {
          if (res.data.status === true) {
            //  if (state.moniter.length === undefined) {
            axios({
              url: host + `tasks/assign/monitor/${props.id}`,
              method: "PUT",
              headers: headers,
              data: {
                monitor_user_id: selectedUser?.id,
              },
            }).then((res) => {
              setLoading(false);
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
              setSpin(true);
              if (props.onRefTask != null) {
                const { onRefTask } = props.onRefTask;
                onRefTask();
              }
              toast.success("Task updated successfully");
            });
            //  }
          } else if (res.data.status === false) {
            toast.error(res.data.data.message.text);
            setLoading(false);
            dispatch(setGlobalLoading(false));
            setSpin(true);
            props?.setAddForm(false);
          }
        })
        .catch((err) => {
          toast.error("Network Error");
          console.log(err);
          setLoading(false);
          dispatch(setGlobalLoading(false));
          setSpin(true);
        });
    }
  };
  useEffect(() => {
    if (taskType1 && taskType1?.id) {
      setTypeId(taskType1?.id);
    } else {
      setTypeId("");
    }
  }, [taskType1]);

  const clearForm = () => {};

  useEffect(() => {
    console.log("propsData", props);
    if (props?.addForm) {
      let getIndex = props?.allstatus?.findIndex(
        (element) => element?.label === props?.status
      );
      let getIndex1 = props?.type?.findIndex(
        (element) => element?.label === props?.task_type
      );
      setStatusId(props?.allstatus[getIndex]);
      setDescription(props?.desc);
      setCustomer(props?.customer?.name);
      setCustomerId(props?.customer?.id);
      setMoniter(props?.moniter?.id);
      setType(props?.type);
      setTaskType1(props?.createMode ? null : props?.type[getIndex1]);
      setStartDate(
        props?.createMode
          ? null
          : props?.time === "1970-01-01T00:00:00.000Z"
          ? ""
          : new Date(props?.time)
      );
      if (props?.geofences?.geo_name) {
        console.log("geo_name", props?.geofences?.geo_name);
        setSelectedGeofence({
          label: props?.geofences?.geo_name,
          value: JSON.parse(props?.geofences?.geo_x),
          dimen: [
            JSON.parse(props?.geofences?.geo_x),
            JSON.parse(props?.geofences?.geo_y),
          ],
        });
      }
      setGeofences(
        props.Geofences?.map((label) => ({
          label: label?.name,
          value: label?.x,
          dimen: [label?.x, label?.y],
        }))
      );
      setWeight(props?.weight);
    }
  }, [props?.addForm]);

  return (
    <PopupForm
      open={props.addForm}
      setOpen={props.setAddForm}
      title={props?.createMode ? "Create New Task" : "Edit Task"}
      content={
        <RenderContent
          handleGeo={handleGeo}
          taskTitle={taskTitle}
          setTaskTitle={setTaskTitle}
          taskType={props?.task_type}
          taskType1={taskType1}
          setTaskType1={setTaskType1}
          customers={customers}
          selectedCustomer={selectedCustomer}
          selected={selected}
          setSelected={setSelected}
          description={description}
          setDescription={setDescription}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          weight={weight}
          setWeight={setWeight}
          startDate={startDate}
          handleChange={handleChange}
          handleChangeweight={handleChangeweight}
          numOfUnits={numOfUnits}
          setNumOfUnits={setNumOfUnits}
          contactedNum={contactedNum}
          setContactedNum={setContactedNum}
          contactedPerson={contactedPerson}
          setContactedPerson={setContactedPerson}
          selectedGeofence={selectedGeofence}
          setSelectedGeofence={setSelectedGeofence}
          geofences={geofences}
          type={type}
          users={users}
          open={props.addForm}
          setOpen={props.setAddForm}
          onRefreshGeo={props.onRefreshGeo}
          setTypeId={setTypeId}
          createMode={props?.createMode}
          selectedAssigners={selectedAssigners}
          setSelectedAssigners={setSelectedAssigners}
          setIsDeadLine={setIsDeadLine}
          isDeadLine={isDeadLine}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={submit}
        />
      }
    />
  );
}
